import React, { useState, useEffect } from "react";
import Button from "../Button";
import useDebounce from "../../hooks/useDebounce";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

const Form = ({
  children,
  onSubmit,
  initialFormData = {},
  className = "",
  debounceTime = 1000,
  handleChange,
  textSubmit,
  textLoadingSubmit,
  handleBack,
  showButtons = true,
  disabledSubmitButton = false,
  showButtonBack = true,
  onBack,
}) => {
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const { debouncedFn: debouncedSubmit, isPending } = useDebounce(
    async (data) => {
      await onSubmit(data);
    },
    debounceTime,
  );

  useEffect(() => {
    setFormData(initialFormData);
  }, []);

  const defaultHandleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const changeHandler = handleChange || defaultHandleChange;

  const handleKeyDown = (e) => {
    // Verifica se a tecla pressionada é Enter (código 13 ou key 'Enter')
    // E garante que não estamos bloqueando o Enter em campos que PRECISAM dele (ex: textarea)
    if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
      e.preventDefault();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    debouncedSubmit(formData).finally(() => {
      setIsSubmitting(false);
    });
  };

  return (
    <form
      className={`${className}`}
      onSubmit={handleSubmit}
      onKeyDown={handleKeyDown}>
      {typeof children === "function"
        ? children({ formData, handleChange: changeHandler })
        : children}
      {showButtons && (
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            my: 2,
            justifyContent: "flex-end",
          }}>
          <Button
            type="submit"
            variant="contained"
            text={isSubmitting || isPending ? textLoadingSubmit : textSubmit}
            className={`btn btn-blue-light fw-semibold ${
              isSubmitting || isPending || disabledSubmitButton
                ? "disabled"
                : ""
            }`}
            disabled={isSubmitting || isPending || disabledSubmitButton}
          />
          {showButtonBack && (
            <Button
              type="button"
              text="Voltar"
              className="btn btn-blue-light fw-semibold"
              onClick={onBack || (() => navigate(-1))}
            />
          )}
        </Box>
      )}
    </form>
  );
};

export default Form;
